import { render } from "./ApthScheduleForm.vue?vue&type=template&id=25b81c94"
import script from "./ApthScheduleForm.vue?vue&type=script&lang=js"
export * from "./ApthScheduleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__